import { useRef } from "react";

import { TSTFilterBar, TSTPagination, TSTTable } from "@impero-com/ui";
import { OnChangeFn, RowSelectionState } from "@tanstack/react-table";
import { Control } from "react-hook-form";

import { TestingControlFormSchema } from "../testingControlSchema";

import {
    useSelectControlsTable,
    getFilterComponent,
} from "./useSelectControlsTable";

interface SelectControlsTableProps {
    onRowSelectionChange: OnChangeFn<RowSelectionState>;
    rowSelection: RowSelectionState;
    selectedControlIdsFieldValue: string[] | undefined;
    control: Control<TestingControlFormSchema>;
}

export function SelectControlsTable({
    rowSelection,
    onRowSelectionChange,
    selectedControlIdsFieldValue,
    control,
}: SelectControlsTableProps) {
    const tableRef = useRef<HTMLDivElement>(null);
    const { table, t, data } = useSelectControlsTable(
        rowSelection,
        onRowSelectionChange,
        selectedControlIdsFieldValue,
        control
    );

    return (
        <div>
            <TSTFilterBar
                table={table}
                addLabel={t("FilterBar_AddFilter")}
                globalSearchLabel={t("FilterBar_GlobalSearchPlaceholder")}
                getFilterCountLabel={(count) =>
                    t("FilterBar_FiltersApplied", { count })
                }
                rowCountLabel={t("FilterBar_RowCount", {
                    count: table.getPrePaginationRowModel().rows.length,
                })}
                hideFiltersLabel={t("FilterBar_HideFilters")}
                clearAllLabel={t("FilterBar_ClearAll")}
                getFilterComponent={(col) => getFilterComponent(t, col, data)}
            />

            <TSTTable
                tableRef={tableRef}
                table={table}
                noResultsFallback={t("TestingControlView_BulkAdd_NoResults")}
                noSourceRowsFallback={t(
                    "TestingControlView_BulkAdd_NoSourceRows"
                )}
            />
            <TSTPagination
                tableElement={tableRef}
                table={table}
                pageLabel={t("Pagination_Page")}
                getRowCountLabel={(shown, count) =>
                    t("Pagination_RowCount", { shown, count })
                }
                getSinglePageRowCountLabel={(count) =>
                    t("Pagination_RowCountSinglePage", { count })
                }
            />
        </div>
    );
}
